import { render, staticRenderFns } from "./courseBanner.vue?vue&type=template&id=bccc3f7e&scoped=true&"
import script from "./courseBanner.vue?vue&type=script&lang=js&"
export * from "./courseBanner.vue?vue&type=script&lang=js&"
import style0 from "./courseBanner.vue?vue&type=style&index=0&id=bccc3f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc3f7e",
  null
  
)

export default component.exports